var poll_default = {
  "fontElementMap": "_1LaTs",
  "container": "FtV4w",
  "fullscreen": "IzR5H",
  "background_overlay": "t0WMB",
  "with_image": "HIIc9",
  "options": "_8YAMT",
  "webview": "OloSI",
  "grid": "L4tsC",
  "option": "gS3Vh",
  "cta_button": "Nfi06",
  "add_option": "_8FnH6",
  "see_more": "-g8Ie",
  "list": "djE85",
  "column": "d6ZrO",
  "additional_note": "RNB9u",
  "spinner": "TupF5",
  "spin": "TJURK",
  "shown": "Gg66w",
  "error": "TTGyR"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
